import CloseIcon from '@mui/icons-material/Close';
import { DialogActions, DialogContent, DialogTitle } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import CustomInput from '../../../components/CustomInput';
import { ControlpanelSecondaryButton, ControlpanelSuccessButton, GrayIconButton } from '../../../components/StyledButton';
import { CustomDialog } from '../../../components/StyledComponents';
import SendIcon16pxSvg from './../../../assets/images/icons/SendIcon16pxSvg';

const SendTokenByEmailDialog = ({ onClose }) => {
   const { t } = useTranslation();
   const [formData, setFormData] = useState({
      sendByEmail: '',
   });
   const [validationMessages, setValidationMessages] = useState({
      sendByEmail: '',
   });
   const handleInputChange = (e) => {
      const { name, value } = e.target;
      setFormData((prevData) => ({
         ...prevData,
         [name]: value,
      }));
   };

   return (
      <CustomDialog transitionDuration={300} maxWidth={'sm'} open onClose={onClose} keepMounted>
         <DialogTitle>
            <div className='flex justify-between'>
               <div className='flex items-center gap-4'>
                  <p className='text-xl font-semibold '>{t('common.send-by-email')}</p>
               </div>
               <GrayIconButton onClick={onClose}>
                  <CloseIcon />
               </GrayIconButton>
            </div>
         </DialogTitle>

         <DialogContent>
            <CustomInput
               required={true}
               title={t('common.email-address')}
               inputType='text'
               name='sendByEmail'
               placeholder='Email address'
               message={validationMessages.sendByEmail}
               handleInputChange={handleInputChange}
               value={formData.sendByEmail}
            />
         </DialogContent>

         <DialogActions>
            <div className='flex gap-2 px-4 py-4'>
               <ControlpanelSuccessButton onClick={onClose}>
                  <SendIcon16pxSvg />
                  <p>{t('button.send')}</p>
               </ControlpanelSuccessButton>
               <ControlpanelSecondaryButton onClick={onClose}>
                  <CloseIcon />
                  <p>{t('button.close')}</p>
               </ControlpanelSecondaryButton>
            </div>
         </DialogActions>
      </CustomDialog>
   );
};

export default SendTokenByEmailDialog;
